<p-dialog header="Ký điện tử không thành công" [(visible)]="pluginNotFound" [style]="{width: '580px'}"
  [resizable]="false">
  <div class="p-grid">
    <div class="p-col-2 p-text-center">
      <img src="/assets/images/usb-not-connected-icon.png" alt="">
    </div>
    <div class="p-col-10">
      <p><b>Hãy kiểm tra các trường hợp dưới đây để khắc phục vấn đề của bạn</b></p>
      <p><b>1.</b> Bạn chưa cài đặt phần mềm ký điện tử Home Casta Invoice hoặc bản cài của bạn cần cập nhật</p>
      <p class="p-pl-4">Hãy cài đặt phần mềm ký điện tử Home Casta Invoice để tiếp tục.</p>
      <p class="p-pl-4"><a target="_blank" rel="noopener noreferrer" href="/assets/tools/HomeCastaSetup.zip"><i
            class="pi pi-download"></i> Tải bộ cài</a></p>

      <p><b>2.</b> Bạn đã cài đặt công cụ <b>Ký số điện tử Home Casta Invoice</b></p>
      <p class="p-pl-4">Hãy mở công cụ <b>Ký số điện tử Home Casta Invoice</b> trước khi ký điện tử</p>
      <p class="p-pl-4"><a style="color: red" href="homeCastaToken:123"><i class="pi pi-info-circle"></i> Mở phần mềm ký
          điện tử Home Casta Invoice</a></p>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
      (onClick)="pluginNotFound=false"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="Chọn hình thức ký" [(visible)]="isTypeSelectionVisible" [style]="{width: '550px'}"
  styleClass="no-scroll" [resizable]="false" (onHide)="cancel()">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <p-dropdown id="type" [(ngModel)]="selectedType" [options]="signingTypes" optionValue="value"
        optionDisabled="disabled" (onChange)=typeSelect($event)></p-dropdown>
      <small class="p-error" *ngIf="selectedTypeReason">{{ selectedTypeReason }}</small>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Xác nhận'|translate }}" styleClass="p-button-raised" (onClick)="submit()"
      [disabled]="submitting"></p-button>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
      (onClick)="cancel()"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="Chọn CTS" [(visible)]="isCtsSelectionVisible" [style]="{width: '550px'}" styleClass="no-scroll"
  [resizable]="false" (onHide)="cancel()">
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12">
      <label for="type2">{{ 'CTS'|translate }}<span class="required">*</span></label>
      <p-dropdown id="type2" [(ngModel)]="selectedCTS" optionLabel="label" optionValue="value" [options]="items"
        (onChange)="onCTSChange($event.value)"></p-dropdown>
    </div>
    <div class="p-field p-col-12" *ngIf="displayPinCode">
      <form [formGroup]="form">
        <label for="pinCode">{{ 'Mã PIN'|translate }}<span class="required">*</span></label>
        <input pInputText type="text" id="pinCode" formControlName="pinCode">
      </form>
    </div>
  </div>
  <p-footer>
    <p-button label="Ký xác thực" styleClass="p-button-raised" (onClick)="submit2()" [disabled]="submitting"></p-button>
    <p-button label="{{ 'Close'|translate }}" styleClass="p-button-raised p-button-text p-button-plain"
      (onClick)="cancel()"></p-button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="isMysignWaitVisible" [closable]="false"
  [style]="{width: '413px', height:'230px', boxShadow:' 8px rgba(0, 0, 0, 0.2)', borderRadius:'10px'}"
  styleClass="no-scroll" [resizable]="false">
  <div *ngIf="selectedType!=='IntrustRemoteSigning'" [style]="{textAlign:'center'}">
    <div class="spinner"></div>
    <div class="message">
      <span>Đã gửi yêu cầu ký đến ứng dụng Mysign.</span>
      <br>
      Vui lòng truy cập ứng dụng để thực hiện ký xác thực
    </div>
    <div class="countdown" id="countdown">
      <b>{{ minutes < 10 ? '0' + minutes : minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }}</b>
    </div>
    <div class="note">
      Xem hướng dẫn ký trên Mysign tại
      <a href="https://www.youtube.com/watch?v=2zGfwoLBNHc" target="_blank">đây</a>
    </div>
  </div>
  <div *ngIf="selectedType === 'IntrustRemoteSigning'" [style]="{textAlign:'center'}">
    <div class="spinner"></div>
    <div class="message">
      <span>Đang ký xác thực trên Intrust...</span>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="isSigningProcessVisible" [modal]="true" [closable]="false"
  [style]="{width: '500px', height:'200px'}" styleClass="no-scroll" [resizable]="false">
  <div [style]="{textAlign:'center'}">
    <div class="spinner"></div>
    <div class="message2">
      <b>Đang ký xác thực...</b>
    </div>
  </div>
</p-dialog>

<p-dialog header="Danh sách hóa đơn đang phát hành hàng loạt" [(visible)]="isBatchSigningViewVisible"
  [modal]="true" [style]="{width: '80vw'}" [contentStyle]="{'max-height': '60vh', 'overflow': 'auto'}"
  [baseZIndex]="11000" [resizable]="false">
  <p-table [value]="batchSigningInvoices" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    responsiveLayout="scroll">
    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 60px">
        <col style="width: 140px">
        <col style="width: 130px">
        <col style="width: 130px">
        <col style="width: 280px">
        <col style="width: 140px">
        <col style="width: 170px">
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 60px;">STT</th>
        <th style="width: 140px;">Ký hiệu</th>
        <th style="width: 130px;">Số hóa đơn</th>
        <th style="width: 130px;">Ngày hóa đơn</th>
        <th style="width: 280px;">Khách hàng</th>
        <th style="width: 140px;">Tổng tiền</th>
        <th style="width: 170px;">Trạng thái</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice let-rowIndex="rowIndex">
      <tr>
        <td style="width: 60px;">{{ rowIndex + 1 }}</td>
        <td style="width: 140px;">{{ getBatchSigningInvoiceSerial(invoice) }}</td>
        <td style="width: 130px;">{{ getInvoiceField(invoice, ['invoiceNo', 'invoiceNumber', 'no']) }}</td>
        <td style="width: 130px;">{{ getInvoiceField(invoice, ['invoiceDate', 'issuedDate', 'date']) | date:'dd/MM/yyyy' }}</td>
        <td style="width: 280px;">{{ getInvoiceField(invoice, ['toPartyName', 'customerName', 'buyerName', 'partyName']) }}</td>
        <td style="width: 140px;" class="p-text-right">{{ getInvoiceField(invoice, ['invoiceTotal', 'grandTotal', 'totalAmount']) | number }}</td>
        <td style="width: 170px;">{{ getInvoiceField(invoice, ['issueStatus', 'status', 'issueStatusId']) }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="p-text-center">Không có dữ liệu</td>
      </tr>
    </ng-template>
  </p-table>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times"
      styleClass="p-button-raised p-button-text p-button-plain" (onClick)="isBatchSigningViewVisible=false">
    </p-button>
  </p-footer>
</p-dialog>
